import { useHMSHlsState } from "../hms";
import { useLivekitHlsState } from "../livekit";
import { useProviderHook } from "./useProviderHook";

export const useProviderHlsState = () =>
  useProviderHook({
    hms: useHMSHlsState,
    livekit: useLivekitHlsState,
  })();
